import { render, staticRenderFns } from "./WxReply.vue?vue&type=template&id=785ea490&scoped=true"
import script from "./WxReply.vue?vue&type=script&lang=js"
export * from "./WxReply.vue?vue&type=script&lang=js"
import style0 from "./WxReply.vue?vue&type=style&index=0&id=785ea490&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785ea490",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('785ea490')) {
      api.createRecord('785ea490', component.options)
    } else {
      api.reload('785ea490', component.options)
    }
    module.hot.accept("./WxReply.vue?vue&type=template&id=785ea490&scoped=true", function () {
      api.rerender('785ea490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wechat/WxReply.vue"
export default component.exports